import { toast } from '@/components/ui/helpers/toast';

import { Button } from '@/components/ui/button';

export function showResumeToast(_email: string, onStartOver: () => void) {
  toast.success(
    <div className="flex flex-col gap-1">
      <span>Welcome back! Continuing from where you left off.</span>
      <Button
        type="button"
        variant="link"
        size="sm"
        onClick={() => {
          onStartOver();
          toast.dismiss();
        }}
        className="h-auto p-0 text-left text-sm"
      >
        Start over instead
      </Button>
    </div>,
    {
      duration: 8000,
    }
  );
}
